<prt-or-plan-page [today]="today" [viewType]="viewType"></prt-or-plan-page>
<prt-or-plan-page *ngIf="isMultiView" [today]="today" [viewType]="viewTypeLT"></prt-or-plan-page>
<prt-measures-page [today]="today"></prt-measures-page>
